module.exports = __webpack_public_path__ + "static/media/hero-slider-img-2.4ac431e4.webp";